export const logger = console;
export type Logger = typeof logger;
